module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (_vm.show_done) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.payment_message))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "https://prep.cityneeds.ng/pricing"
    }
  }, [_vm._v("Go Back")])]) : _c('div', {
    staticClass: "container"
  }, [(_vm.amount_topay > 0) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.amount_topay))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance > _vm.amount_topay) ? _c('div', [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _vm._e()]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process Payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])]) : _vm._e(), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h1', [_vm._v("CNpro Plans & Pricing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Make Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em",
      "text-align": "left"
    }
  }, [_c('p', [_c('b', [_vm._v("WHY YOU HAVE TO SUBSCRIBE BEFORE YOU CAN CONTACT CNpros:")])]), _vm._v(" "), _c('p', [_vm._v("Finding diligent workers is HARD. Ensuring that workers keep transactions within the loop is EVEN HARDER. "), _c('br'), _vm._v("\r\n                             Subscription fees guarantees that insurance is in place, and keeps conflict mediation mechanism active.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33f4f7bf"}!./src/components/PricingPayments/template.html
// module id = 279
// module chunks = 0